export default "__VITE_ASSET__Byi4ZW2h__"